import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged, takeUntil } from 'rxjs/operators';
import { NgxTolgeeModule, TranslateService } from '@tolgee/ngx';

@Component({
	selector: 'au-search-input',
	templateUrl: './au-search-input.component.html',
	styleUrls: ['./au-search-input.component.scss'],
	imports: [
		CommonModule,
		MatFormFieldModule,
		MatInputModule,
		FormsModule,
		MatIconModule,
		ReactiveFormsModule,
		NgxTolgeeModule,
	],
})
export class AuSearchInputComponent implements OnInit, OnDestroy {
	constructor(private translateService: TranslateService) {}

	@Input() set value(text: string) {
		this.formControl.setValue(text);
	}
	@Input() placeholder = this.translateService.instant('search');
	@Input() containerClass: string;
	@Input() subscriptSizingMode: 'dynamic' | 'fixed' = 'fixed';
	@Output() searchTextChanged = new EventEmitter<string>();
	@Output() focusChanged = new EventEmitter<boolean>();

	formControl = new FormControl<string>('');

	private destroy$ = new Subject<void>();

	ngOnInit(): void {
		this.formControl.valueChanges
			.pipe(takeUntil(this.destroy$), debounceTime(200), distinctUntilChanged())
			.subscribe(value => {
				this.searchTextChanged.emit(value);
			});
	}

	ngOnDestroy() {
		this.destroy$.next();
		this.destroy$.complete();
	}
}
